import {SignalRHub} from 'constants/dataEnum';

export const selectIsInstrumentControlHubConnected = (state) =>
  state.signalrState[SignalRHub.INSTRUMENT]?.connectionState === 'Connected';

export const selectIsSoftwareUpdaterHubConnected = (state) =>
  state.signalrState[SignalRHub.SOFTWARE_UPDATER]?.connectionState === 'Connected';
